import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=5f3145e6&scoped=true&"
import script from "./Wallet.vue?vue&type=script&lang=ts&"
export * from "./Wallet.vue?vue&type=script&lang=ts&"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=5f3145e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3145e6",
  null
  
)

export default component.exports